import {useContext} from "react";
import {AuthContext} from "contexts/auth/auth.provider";

export default function NoResults({onClearSearch}) {
    const {deviceType} = useContext(AuthContext);
    return (
        <div className="">
            <div className="w-full mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
                <h2 className="text-3xl leading-9 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
                    Not finding what you're looking for?
                </h2>
                <h3 className="text-xl leading-9 font-bole tracking-tight text-gray-800 sm:text-xl sm:leading-10">
                    Let us know and we'll try our best to assist.
                </h3>
                <div className="mt-8 flex justify-center">
                    <div className="inline-flex rounded-md shadow">
                        <a
                            href="mailto:info@scuttle.co.za"
                            className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-bold rounded-md text-white bg-scuttle-orange"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>
            </div>
        </div>

    );
}
